"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = __importDefault(require("../../Button/Button"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var IcoInputField_1 = __importDefault(require("./IcoInputField"));
var StyledLabel = styled_components_1.default(function (props) { return react_1.default.createElement(Label_1.default, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media only screen and (max-width: 640px) {\n    align-self: flex-start;\n    margin-top: 12px;\n  }\n"], ["\n  @media only screen and (max-width: 640px) {\n    align-self: flex-start;\n    margin-top: 12px;\n  }\n"])));
var StyledButton = styled_components_1.default(Button_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 50px;\n  margin-left: 8px;\n\n  @media only screen and (max-width: 640px) {\n    margin: 10px 0 0 0;\n    flex-direction: column;\n  }\n"], ["\n  height: 50px;\n  margin-left: 8px;\n\n  @media only screen and (max-width: 640px) {\n    margin: 10px 0 0 0;\n    flex-direction: column;\n  }\n"])));
var ErrorMessage = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 5px;\n  color: red;\n"], ["\n  margin-top: 5px;\n  color: red;\n"])));
var InputDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  @media only screen and (max-width: 640px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  @media only screen and (max-width: 640px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"])));
var IcoFieldWithButton = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, onClick = _a.onClick, showButton = _a.showButton, buttonName = _a.buttonName, loading = _a.loading, toolTip = _a.toolTip, druhOsoby = _a.druhOsoby, primaryButton = _a.primaryButton, resetError = _a.resetError, onError = _a.onError;
    var _b = react_1.useState(undefined), errorMessage = _b[0], setErrorMessage = _b[1];
    var handleError = function (mess) {
        setErrorMessage(mess);
        if (onError)
            onError(mess !== undefined);
    };
    react_1.useEffect(function () {
        setErrorMessage(undefined);
    }, [resetError]);
    return (react_1.default.createElement(Field_1.default, null,
        label && react_1.default.createElement(StyledLabel, { htmlFor: name }, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement(InputDiv, null,
                react_1.default.createElement(IcoInputField_1.default, { name: name, size: size, readOnly: readOnly, toolTip: toolTip, icoValidation: true, druhOsoby: druhOsoby, setErrorMessage: function (mess) { return handleError(mess); } }),
                showButton && (react_1.default.createElement(StyledButton, { onClick: onClick, loading: loading, name: buttonName || 'Tlacitko', primary: primaryButton, disabled: errorMessage !== undefined }, buttonName))),
            errorMessage && react_1.default.createElement(ErrorMessage, null, errorMessage))));
};
IcoFieldWithButton.defaultProps = {
    size: undefined,
    label: undefined,
    readOnly: false,
    onClick: undefined,
    showButton: false,
    buttonName: undefined,
    toolTip: undefined,
    loading: undefined,
    druhOsoby: undefined,
    primaryButton: undefined,
    resetError: undefined,
    onError: undefined,
};
exports.default = IcoFieldWithButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
